export const SUPPORT_CATEGORIES = {
  BUG_REPORT: 'bug_report',
  TECHNICAL_SUPPORT: 'technical_support',
  ACCOUNT_ACCESS: 'account_access',
  BILLING_SUBSCRIPTION: 'billing_subscription',
  FEATURE_REQUEST: 'feature_request',
  GENERAL_QUESTION: 'general_question',
};

export const SUPPORT_CATEGORY_OPTIONS = [
  { value: SUPPORT_CATEGORIES.BUG_REPORT, label: 'Bug report' },
  { value: SUPPORT_CATEGORIES.TECHNICAL_SUPPORT, label: 'Technical support' },
  { value: SUPPORT_CATEGORIES.ACCOUNT_ACCESS, label: 'Account access' },
  { value: SUPPORT_CATEGORIES.BILLING_SUBSCRIPTION, label: 'Billing/subscription' },
  { value: SUPPORT_CATEGORIES.FEATURE_REQUEST, label: 'Feature request' },
  { value: SUPPORT_CATEGORIES.GENERAL_QUESTION, label: 'General question' },
];

export const SUPPORT_PLATFORM_OPTIONS = [
  { value: 'web', label: 'Web' },
  { value: 'ios_app', label: 'iOS app' },
];

export const SUPPORT_BILLING_PLATFORM_OPTIONS = [
  { value: 'web', label: 'Web' },
  { value: 'ios_app_store', label: 'iOS App Store' },
];

export const SUPPORT_SEVERITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const SUPPORT_ACCOUNT_ACCESS_ISSUE_OPTIONS = [
  { value: 'login', label: 'Login' },
  { value: 'verification', label: 'Verification' },
  { value: 'subscription_access', label: 'Subscription access' },
  { value: 'missing_data', label: 'Missing data' },
];

export const SUPPORT_BILLING_ISSUE_OPTIONS = [
  { value: 'purchase', label: 'Purchase' },
  { value: 'restore', label: 'Restore' },
  { value: 'charged_incorrectly', label: 'Charged incorrectly' },
  { value: 'plan_mismatch', label: 'Plan mismatch' },
];

export const SUPPORT_FIELD_LABELS = {
  category: 'Category',
  subject: 'Subject',
  message: 'Message',
  platform: 'Platform',
  severity: 'Severity',
  stepsToReproduce: 'Steps to reproduce',
  expectedBehavior: 'Expected behavior',
  actualBehavior: 'Actual behavior',
  featureArea: 'Feature or area',
  whatHappened: 'What happened',
  issueType: 'Issue type',
  desiredOutcome: 'Desired outcome',
  screenshot: 'Screenshot',
};

const CATEGORY_FIELDS = {
  [SUPPORT_CATEGORIES.BUG_REPORT]: [
    'platform',
    'severity',
    'stepsToReproduce',
    'expectedBehavior',
    'actualBehavior',
    'screenshot',
  ],
  [SUPPORT_CATEGORIES.TECHNICAL_SUPPORT]: ['platform', 'featureArea', 'whatHappened'],
  [SUPPORT_CATEGORIES.ACCOUNT_ACCESS]: ['issueType', 'whatHappened'],
  [SUPPORT_CATEGORIES.BILLING_SUBSCRIPTION]: ['platform', 'issueType'],
  [SUPPORT_CATEGORIES.FEATURE_REQUEST]: ['featureArea', 'desiredOutcome'],
  [SUPPORT_CATEGORIES.GENERAL_QUESTION]: [],
};

export const getSupportFieldsForCategory = (category) => {
  return CATEGORY_FIELDS[category] || [];
};

export const createInitialSupportFormState = () => ({
  category: SUPPORT_CATEGORIES.BUG_REPORT,
  subject: '',
  message: '',
  platform: 'web',
  severity: 'medium',
  stepsToReproduce: '',
  expectedBehavior: '',
  actualBehavior: '',
  featureArea: '',
  whatHappened: '',
  issueType: 'login',
  desiredOutcome: '',
  screenshot: null,
});

export const getCategoryOptionLabel = (category) => {
  return SUPPORT_CATEGORY_OPTIONS.find((option) => option.value === category)?.label || 'Support';
};
